import { DATE_TEMPLATES, day, diff, format, getNow } from '~/astra'

type ActivityType = 'create' | 'delete' | 'update'

export function getActivityTypeLabel(activityType: ActivityType): string {
    switch (activityType) {
        case 'create':
            return 'la til'
        case 'update':
            return 'endret'
        case 'delete':
            return 'fjernet'
    }
}

export function formatDate(date: string) {
    const dayjsDate = day(date)
    const now = getNow()
    const deltaSeconds = diff(now, dayjsDate, 'second')
    if (deltaSeconds < 60) return 'nå'
    const deltaMinutes = diff(now, dayjsDate, 'minute')
    if (deltaMinutes < 60) return `${deltaMinutes} min`
    const deltaHours = diff(now, dayjsDate, 'hour')
    if (deltaHours < 24) return `${deltaHours} t`
    return format(dayjsDate, DATE_TEMPLATES.compactDateTime)
}
